import { Tooltip } from "bootstrap"

const initTooltips = () => {
  document.querySelectorAll('[data-bs-toggle="tooltip"]:not([data-bs-tooltip-initialized])').forEach((element) => {
    new Tooltip(element)
    element.dataset.bsTooltipInitialized = "true"
  })
}

// Turbo caches the DOM with the initialized marker still on it, but the Bootstrap
// instances do not survive the snapshot. Dispose them and clear the marker, so the
// restored page initializes its tooltips again instead of silently having none.
const disposeTooltips = () => {
  document.querySelectorAll("[data-bs-tooltip-initialized]").forEach((element) => {
    const tooltip = Tooltip.getInstance(element)
    if (tooltip) tooltip.dispose()
    delete element.dataset.bsTooltipInitialized
  })
}

document.addEventListener("turbo:load", initTooltips)
document.addEventListener("turbo:before-cache", disposeTooltips)
